import apiClient from '@shared/api'
import { installRequestInterceptor } from '@shared/utils/interceptors/requestInterceptor'
import { ERouterList } from '@urgent/router/constants/router-list'
import type { IRouteContext } from '@shared/types/route-context'
import { getVisitGuestToken } from '@shared/api/visits/anonymous'
import { useComposition } from '@shared/utils/composables/meeting'
import { decodeJwt } from '../../utils/jwtDecoder'

const { guestToken } = useComposition()

export const guest = async ({ to, next }: IRouteContext): Promise<void> => {
  const code: string = to.query.code ? (to.query.code as string) : ''
  let { token, scheduledTime } = await getVisitGuestToken({ code })

  const decodedToken = decodeJwt(token)
  const now = Date.now() / 1000

  if (decodedToken && decodedToken.nbf > now) {
    return next({
      name: ERouterList.NOT_READY,
      query: {
        scheduledTime
      }
    })
  }

  installRequestInterceptor({ apiClient, sessionToken: token })
  guestToken.value = token

  return token
    ? next()
    : next({
        name: ERouterList.HOME
      })
}
